import { DropdownSelectOption } from 'components/UI/V2/DropdownSelect/DropdownSelect';
import moment from 'moment-timezone';
import React from 'react';

export const useSessionHourOptions = (): Array<DropdownSelectOption<string>> => {
    return React.useMemo(() => {
        const hours: Array<DropdownSelectOption<string>> = [];
        const time = moment().startOf('day');
        const end = moment().endOf('day');

        while (time.isBefore(end)) {
            hours.push({ label: time.format('LT'), value: time.format('HH:mm') });
            time.add(30, 'minutes');
        }

        return hours;
    }, []);
};
